import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const  layer00368 = new TileLayer({
  title: 'Máscara 19921002',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19921002l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00368.setVisible(false);

const layer00367 = new TileLayer({
  title: 'Máscara 19930106',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19930106l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00367.setVisible(false);

const layer00366 = new TileLayer({
  title: 'Máscara 19930615',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19930615l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00366.setVisible(false);

const layer00365 = new TileLayer({
  title: 'Máscara 19930717',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19930717l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00365.setVisible(false);

export const grupoCapa01_29 = new LayerGroup({
  title: 'Ciclo Hidrológico 1992-1993',
  fold: 'close',
  layers: [layer00365, layer00366, layer00367, layer00368]
});